// import { Link } from '@reach/router';
import * as React from 'react';
// import { TranslationFn, useTranslations } from '../../../common/translation';
// import translations from '../translations';
import { CarouselItemTitleTwoProps } from './CarouselItemTitleTwo.props';
import { StyledCarouselItemHeaderTwo } from './CarouselItemTitleTwo.styles';
// import { StyledCarouselItemHeaderTwo, StyledCarouselItemTitleTwo } from './CarouselItemTitleTwo.styles';

export const carouselItemTitleValue = 'item-title';

/* const getTypeLabel = (type: ContentType | undefined, isMobileGameOrApp: boolean | undefined, t: TranslationFn) => {
  switch (type) {
    case 'Games & Apps':
      return isMobileGameOrApp ? t('Mobile Apps', 'Mobile Apps') : t('Video Games', 'Video Games');
    case 'Movies':
    case 'TV Seasons':
    case 'TV Series':
      return t(type, type);
    default:
      return '';
  }
}; */

export const CarouselItemTitleTwo = ({ marketingMessage }: CarouselItemTitleTwoProps) => {
  // const { t } = useTranslations(translations);
  // const typeLabel = getTypeLabel(type, isMobileGameOrApp, t);

  return (
    <StyledCarouselItemHeaderTwo data-carousel={carouselItemTitleValue}>
      {marketingMessage && <p title={marketingMessage}>{marketingMessage}</p>}
    </StyledCarouselItemHeaderTwo>
  );

  /* return (
    <StyledCarouselItemHeaderTwo data-carousel={carouselItemTitleValue}>
      {typeLabel && <span>{typeLabel}</span>}
      <StyledCarouselItemTitleTwo as={headingTag}>
        <Link to={url}>{title}</Link>
      </StyledCarouselItemTitleTwo>
      {marketingMessage && <p>{marketingMessage}</p>}
    </StyledCarouselItemHeaderTwo>
  ); */
};
